import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { UserInfo, UserRole, userRoleMap } from '../types/user';
import { userService } from '../services';
import { useAuthStore } from './auth';
import { utils } from '../utils';
import defaultAvatar from '../assets/imgs/isaac_avatar.png'
import * as Sentry from '@sentry/vue'

export const useUserStore = defineStore('user', () => {
    const userInfo = ref<UserInfo | null>(null)
    const auth = useAuthStore()
    const username = computed(() => {
        const accessTokenBody = utils.decodeJwt(auth.accessToken)
        return accessTokenBody?.name
    })
    const userRole = computed(() => {
        const accessTokenBody = utils.decodeJwt(auth.accessToken)
        if (accessTokenBody?.role?.split(',').some(role => ['Teacher', 'AC/AO'].includes(role))) {
            accessTokenBody.role = UserRole.teacher
        }
        return accessTokenBody?.role
    })
    const userRoleName = computed(() => userRole.value ? userRoleMap[userRole.value] : '')

    async function getUserInfo() {
        let userInfoData = null
        if (userRole.value === UserRole.student) {
            userInfoData = await userService.getStudentInfo()
        }
        if (userRole.value === UserRole.teacher) {
            userInfoData = await userService.getTeacherInfo()
        }
        //default avatar for no avatar user
        if (userInfoData && !userInfoData.avatar) {
            userInfoData.avatar = defaultAvatar;
        }
        userInfo.value = userInfoData;
        
        Sentry.setUser({
            id: userInfo.value?.id,
            email: userInfo.value?.email,
            username: username.value,
            full_name: userInfo.value?.full_name
        })
    }

    function clearUserInfo() {
        userInfo.value = null;
    }

    return { userInfo, userRole, userRoleName, username, getUserInfo, clearUserInfo }
});
